import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import { routerMiddleware, routerReducer } from 'react-router-redux'
import modals from 'common/redux/modules/modals'
import * as reducers from './modules'
import analytics from 'tickets/redux/middlewares/analytics'

const middlewares = [
  thunkMiddleware,
  routerMiddleware(history),
  analytics,
]

const rootReducer = combineReducers({
  ...reducers,
  modals,
  router: routerReducer,
})

const create = createStore(
  rootReducer,
  composeWithDevTools(
    applyMiddleware(
      ...middlewares,
    ),
  )
)

export default create
